export default function InforCard({ label, profile, icon }) {
  return (
    <div className=" group bg-white rounded-xl p-5  border border-gray-100 shadow-sm hover:shadow-lg hover:border-[#164481]/20 transition-all duration-300 ease-out transform hover:-translate-y-1">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-[#164481]/10 flex items-center justify-center text-black group-hover:bg-black group-hover:text-white transition-colors duration-300">
          {icon}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
            {label}
          </p>
          <p className="text-sm md:text-base font-semibold text-black truncate">
            {profile}
          </p>
        </div>
      </div>
    </div>
  );
}
